<div class="modal-header-block title">
  <h2>Feature Management</h2>
</div>

@if (featureFlagsBoolean$ | async; as featureFlags) {
  <div class="flags-wrapper">
    <div class="flags-section">
      @for (feature of featureList | keyvalue; track feature) {
        <div>
          <div class="switcher-container">
            <div class="switcher">
              <button
                type="button"
                (click)="onSwitch(feature.key)"
                class="input-switch"
                [class.input-switch-checked]="featureFlagsModel[feature.key] === true"
              >
                <div class="input-switch-slider"></div>
              </button>
            </div>
            <div class="switcher-label">{{ feature.value.name }}</div>
          </div>
        </div>
      }
    </div>
  </div>
}

<app-details-item class="block mb-5" label="App run on environment">
  {{ envConfig.name | uppercase }}
  <button
    rktButton
    type="button"
    btnType="secondary"
    class="!inline-flex ml-5 !text-sm !px-3 !py-2"
    title="Reset To Environment Defaults"
    (click)="onEnvPresetClick(envConfig.name)"
  >
    Reset
  </button>
</app-details-item>

<app-details-item class="block mb-5" label="Environments Presets">
  <div class="env-presets">
    @for (envItem of environmentList; track envItem) {
      <button rktButton type="button" btnType="secondary" (click)="onEnvPresetClick(envItem)">
        {{ envItem | uppercase }}
      </button>
    }
  </div>
</app-details-item>

<div class="buttons-container">
  <div class="buttons">
    <button rktButton type="button" btnType="tertiary" (click)="activeModal.close()">Discard</button>
    <button rktButton type="submit" (click)="onSave()" title="Save">Save</button>
  </div>
</div>
